module.exports = __webpack_public_path__ + "static/media/lightning.752c0783.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/lightning.svg
// module id = 1079
// module chunks = 21